import { Children } from 'react';
import PropTypes from 'prop-types';
import styles from './card-resource-container.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';
import Carousel from 'react-bootstrap/Carousel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Icon from '../../../atoms/icon';

const className = augmentClassName(styles);

const CardResourceContainer = ({ children }) => {
  const childrenArr = Children.toArray(children);
  return childrenArr.length ? (
    <>
      <Row {...className('d-none', 'd-md-flex', 'd-print-none')}>
        {childrenArr.filter(Boolean).map((child, index) => (
          <Col data-key={`${child.key || ''}-${index}`} key={`${child.key || ''}-${index}`} xs={3}>
            {child}
          </Col>
        ))}
      </Row>
      <Carousel
        {...className('root', 'd-md-none', 'd-print-none')}
        nextIcon={<Icon.ChevronThick {...className('flip')} />}
        prevIcon={<Icon.ChevronThick />}
        interval={null}
        wrap={false}
      >
        {childrenArr.filter(Boolean).map((child, index) => (
          <Carousel.Item
            data-key={`${child.key || ''}-${index}`}
            key={`${child.key || ''}-${index}`}
          >
            {child}
          </Carousel.Item>
        ))}
      </Carousel>
    </>
  ) : null;
};

CardResourceContainer.propTypes = {
  children: PropTypes.node
};

CardResourceContainer.defaultProps = {
  children: []
};

export default CardResourceContainer;
